import { get, post, patch, del } from "utils/api/apiCaller";
import { ENDPOINTS } from "utils/api/endpoints";
import type { ApiResponse } from "utils/api/apiClient";
import { uploadFileToS3 } from "Pages/GcPrecon/GcPreconCommercial/UploadFileToS3";

export interface ProfileUpdatePayload {
  firstName?: string;
  lastName?: string;
  title?: string;
  phone?: string;
  address?: string;
  timezone?: string;
  email?: string;
  sms2faEnabled?: boolean;
  emailLoginAlertEnabled?: boolean;
  emailEnabled?: boolean;
  smsEnabled?: boolean;
  avatar?: { key: string; fileName: string };
}

export interface ChangePasswordPayload {
  currentPassword: string;
  newPassword: string;
}

export interface NotificationSettingPayload {
  email?: boolean;
  sms?: boolean;
}

export const getMyProfile = (): Promise<ApiResponse> =>
  get(ENDPOINTS.PROFILE.ME);

export const updateMyProfile = (
  payload: ProfileUpdatePayload,
): Promise<ApiResponse> => {
  const { timezone, ...rest } = payload;
  const apiPayload = { ...rest, ...(timezone ? { timeZone: timezone } : {}) };
  return patch(ENDPOINTS.PROFILE.UPDATE, apiPayload);
};

export const changePassword = (
  data: ChangePasswordPayload,
): Promise<ApiResponse> => post(ENDPOINTS.PROFILE.CHANGE_PASSWORD, data);

export const getActiveSessions = (): Promise<ApiResponse> =>
  get(ENDPOINTS.PROFILE.ACTIVE_SESSIONS);

export const revokeSession = (sessionId: string): Promise<ApiResponse> =>
  del(ENDPOINTS.PROFILE.REVOKE_SESSION(sessionId));

export const revokeAllSessions = (): Promise<ApiResponse> =>
  post(ENDPOINTS.PROFILE.REVOKE_ALL_SESSIONS, {});

export const uploadProfilePhoto = async (
  file: File,
): Promise<ApiResponse<{ url: string }>> => {
  try {
    const { key } = await uploadFileToS3(file);
    return post(ENDPOINTS.PROFILE.UPLOAD_PHOTO, { photoKey: key });
  } catch (err: unknown) {
    const message = err instanceof Error ? err.message : "Photo upload failed";
    return { data: null, error: { message } };
  }
};

export const deleteProfilePhoto = (): Promise<ApiResponse> =>
  del(ENDPOINTS.PROFILE.DELETE_PHOTO);

export const sendPhoneVerificationOTP = (): Promise<ApiResponse> =>
  post(ENDPOINTS.PROFILE.SEND_PHONE_OTP, {});

export const verifyPhoneOTP = (otp: string): Promise<ApiResponse> =>
  post(ENDPOINTS.PROFILE.VERIFY_PHONE_OTP, { otp });
